import { localStorageKeys } from "../constants/page";

export const AUTH_CHANNEL = "linkstep-auth";

export function getAccessToken() {
  return localStorage.getItem(localStorageKeys.accessToken);
}

export function getRefreshToken() {
  return localStorage.getItem(localStorageKeys.refreshToken);
}

export function setTokens({ accessToken, refreshToken }) {
  if (accessToken) {
    localStorage.setItem(localStorageKeys.accessToken, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(localStorageKeys.refreshToken, refreshToken);
  }

  window.dispatchEvent(
    new CustomEvent("auth-tokens-changed", {
      detail: { accessToken, refreshToken },
    }),
  );

  try {
    const channel = new BroadcastChannel(AUTH_CHANNEL);
    channel.postMessage({
      type: "tokens",
      accessToken,
      refreshToken,
    });
    channel.close();
  } catch {
    // BroadcastChannel not available
  }
}

export function clearTokens() {
  localStorage.removeItem(localStorageKeys.accessToken);
  localStorage.removeItem(localStorageKeys.refreshToken);
  localStorage.removeItem(localStorageKeys.user);
  sessionStorage.removeItem(localStorageKeys.impersonationCompany);

  window.dispatchEvent(
    new CustomEvent("auth-tokens-changed", { detail: null }),
  );

  try {
    const channel = new BroadcastChannel(AUTH_CHANNEL);
    channel.postMessage({ type: "logout" });
    channel.close();
  } catch {
    // ignore
  }
}
